export default "__VITE_ASSET__24089143__"